/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sales_No_AwaitingInputs */

const vi_dashboard_sales_no_awaiting = /** @type {(inputs: Dashboard_Sales_No_AwaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có đơn nào chờ xác nhận.`)
};

/**

* @param {Dashboard_Sales_No_AwaitingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_sales_no_awaiting = /** @type {((inputs?: Dashboard_Sales_No_AwaitingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sales_No_AwaitingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_sales_no_awaiting(inputs)
});